export default __webpack_public_path__ + "static/media/course.4508d31f.svg";